module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BusinessHallView.js"));
	}, "BusinessHallView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessHallView!./src/pages/Promote/BusinessHall/BusinessHallView.js
// module id = 1139
// module chunks = 431